// "Tasfo · opdateret for 14 min siden": how old the data on a page is (the backend's own timestamps, see utils/freshness.js).
// Hover shows each cached read it rests on. Only fresh data (under an hour) says how many minutes; older data says an update is in progress instead of counting hours.
import React from 'react';
import { ageText } from '../utils/freshness';
import './FreshnessChip.css';

export default function FreshnessChip({ tenantName, freshness }) {
  if (!freshness) return null;
  return (
    <span className={`fresh-chip fresh-chip--${freshness.tone}`} tabIndex={0}>
      <i />{tenantName ? `${tenantName} · ` : ''}{freshness.tone === 'ok' ? <>opdateret for <b>{ageText(freshness.ms)}</b> siden</> : 'opdatering i gang…'}
      <span className="fresh-chip__tip" role="tooltip">
        <b>Tallene bygger på</b>
        {freshness.rows.map((r) => <span key={r.label}><span>{r.label}</span><span>{ageText(r.ms)} siden</span></span>)}
      </span>
    </span>
  );
}
